import { User } from '../models';
import { BaseDAO } from './base.dao';

export class UserDAO extends BaseDAO<User> {}
